var $be9d354476c08087$exports = {};
$be9d354476c08087$exports = {
    "removeButtonLabel": `Supprimer`,
    "removeDescription": `Appuyez sur Supprimer pour supprimer l\u{2019}\xe9tiquette.`
};


export {$be9d354476c08087$exports as default};
//# sourceMappingURL=fr-FR.module.js.map
